<template>
  <div class="collection-grid-wrapper">
    <div class="collection-grid-container">
      <!-- Skeleton -->
      <ul v-if="loading" class="collection-grid">
        <collection-card-skeleton v-for="n in skeletonCount" :key="'skeleton-' + n"/>
      </ul>

      <!-- Empty State -->
      <div v-else-if="showEmpty" class="empty-collection-state">
        <div class="empty-collection-icon">
          <i class="uil-notebooks"></i>
        </div>
        <h4 class="empty-collection-title">{{ emptyTitle }}</h4>
        <p v-if="emptyDescription" class="empty-collection-description">{{ emptyDescription }}</p>
      </div>

      <!-- Collection Items -->
      <ul v-else class="collection-grid">
        <collection
          v-for="item in collections"
          :key="item.id"
          :collection="item"
          @onClickCard="$emit('collection-click', $event)"
        />
      </ul>
    </div>
  </div>
</template>

<script>
import Collection from "@/view/components/index/Collection.vue";
import CollectionCardSkeleton from "./CollectionCardSkeleton.vue";

export default {
  name: "CollectionGrid",

  components: {
    Collection,
    CollectionCardSkeleton,
  },

  props: {
    collections: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    skeletonCount: {
      type: Number,
      default: 8,
    },
    emptyTitle: {
      type: String,
      default: "",
    },
    emptyDescription: {
      type: String,
      default: "",
    },
  },

  computed: {
    showEmpty() {
      return this.collections.length === 0;
    },
  },
};
</script>

<style scoped>
.collection-grid-wrapper {
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

.collection-grid-container {
  position: relative;
  min-height: 400px;
}

.collection-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: 1fr;
  gap: 24px;
  list-style: none;
  padding: 0;
  margin: 24px 0 0 0;
  min-width: 0;
}

.collection-grid > * {
  min-width: 0;
}

/* Collection cards — tıklanabilir: border yok, soft shadow */
.collection-grid :deep(.collection-card),
.collection-grid :deep(.collection-skeleton-card) {
  border: none !important;
  border-radius: 14px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease !important;
  cursor: pointer;
}

.collection-grid :deep(.collection-card:hover) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12) !important;
}

.collection-grid :deep(.collection-card:active) {
  transform: scale(0.98);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
}

@media (max-width: 959px) {
  .collection-grid :deep(.collection-card:hover) {
    transform: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
  }
}

/* Empty State */
.empty-collection-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  margin: 24px 0 0 0;
  min-height: 350px;
}

.empty-collection-icon {
  border-radius: 50%;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.empty-collection-icon i {
  font-size: 48px;
  color: #ffffff;
}

.empty-collection-title {
  font-size: 20px;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 12px 0;
}

.empty-collection-description {
  font-size: 15px;
  color: #718096;
  line-height: 1.6;
  max-width: 400px;
  margin: 0 auto;
}

/* Tablet */
@media (max-width: 1199px) {
  .collection-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }
}

/* Tablet Small */
@media (max-width: 959px) {
  .collection-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  .empty-collection-icon {
    width: 80px;
    height: 80px;
  }

  .empty-collection-icon i {
    font-size: 36px;
  }

  .empty-collection-title {
    font-size: 18px;
  }
}

/* Mobile */
@media (max-width: 639px) {
  .collection-grid-container {
    min-height: 300px;
  }

  .collection-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    margin-top: 16px;
  }

  .empty-collection-state {
    padding: 40px 16px;
    margin: 16px 0 0 0;
    min-height: 250px;
  }

  .empty-collection-icon {
    width: 72px;
    height: 72px;
  }

  .empty-collection-icon i {
    font-size: 32px;
  }

  .empty-collection-title {
    font-size: 16px;
  }

  .empty-collection-description {
    font-size: 14px;
  }
}
</style>
